import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LabelComponent } from './label/label.component';
import { LabelListComponent } from './label-list/label-list.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AddLabelModalComponent } from './add-label-modal/add-label-modal.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { EditLabelModalComponent } from './edit-label-modal/edit-label-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { OverlayModule } from '@angular/cdk/overlay';
import { LabelSelectorAreaComponent } from './label-selector-area/label-selector-area.component';

@NgModule({
    declarations: [
        LabelComponent,
        LabelListComponent,
        AddLabelModalComponent,
        AddLabelModalComponent,
        EditLabelModalComponent,
        LabelSelectorAreaComponent,
    ],
    imports: [
        CommonModule,
        AngularSvgIconModule,
        MatProgressSpinnerModule,
        FormsModule,
        ReactiveFormsModule,
        OverlayModule,
    ],
    exports: [LabelComponent, LabelListComponent, LabelSelectorAreaComponent],
})
export class LabelsModule {}
